export default __webpack_public_path__ + "static/media/parked_car.92a9d147.svg";